import { setSettingForApp } from 'entities/user/module/app-settings'
import userStore from 'entities/user/module/user-store'

import { RealtyCity } from 'shared/api/kyrgyzstan/search'
import { ShareKeys } from 'shared/constants'

import { kyrgyzstanSearchStore } from '../model'
import type { GuestsState } from '../model/guests'

export interface SavedSearchFormState {
  selectedRealtyId?: string | null
  selectedRealtyChildrenId?: string | null
  start_date?: string
  end_date?: string
  cities?: RealtyCity[]
  city?: RealtyCity | null
  guests?: GuestsState
  realty_type_ids?: number[]
  price_min?: number
  price_max?: number
  sort?: string
}

interface DetailSelectionStore {
  selectedRealtyId: string | null
  selectedRealtyChildrenId: string | null
  setSelectedRealtyId: (id: string | null) => void
  setSelectedRealtyChildrenId: (id: string | null) => void
}

export const restoreSearchFormState = (
  searchStore: typeof kyrgyzstanSearchStore,
  detailStore?: DetailSelectionStore,
) => {
  const savedState = userStore.getClientStateParse<SavedSearchFormState>(
    ShareKeys.kyrgyzstan,
  )

  if (!savedState) return

  if (
    detailStore &&
    detailStore.selectedRealtyId == null &&
    savedState.selectedRealtyId != null
  ) {
    detailStore.setSelectedRealtyId(savedState.selectedRealtyId)
  }
  if (
    detailStore &&
    detailStore.selectedRealtyChildrenId == null &&
    savedState.selectedRealtyChildrenId != null
  ) {
    detailStore.setSelectedRealtyChildrenId(savedState.selectedRealtyChildrenId)
  }

  searchStore.previousRequestParams = null
  searchStore.setRealtyList([])

  if (savedState.start_date) {
    searchStore.setStartDate(savedState.start_date)
  }
  if (savedState.end_date) {
    searchStore.setEndDate(savedState.end_date)
  }
  if (savedState.cities?.length) {
    searchStore.setCities(savedState.cities)
  } else if (savedState.city) {
    searchStore.setCities([savedState.city])
  }
  if (savedState.guests) {
    searchStore.setGuests(savedState.guests)
  }
  if (savedState.realty_type_ids) {
    searchStore.setRealtyTypeIds(savedState.realty_type_ids)
  }
  if (
    savedState.price_min !== undefined ||
    savedState.price_max !== undefined
  ) {
    searchStore.setPriceRange(savedState.price_min, savedState.price_max)
  }
  if (savedState.sort) {
    searchStore.setSort(savedState.sort)
  }
}

export const saveSearchFormState = (
  searchStore: typeof kyrgyzstanSearchStore,
  detailState?: Pick<
    SavedSearchFormState,
    'selectedRealtyId' | 'selectedRealtyChildrenId'
  >,
) => {
  const searchFormState: SavedSearchFormState = {
    selectedRealtyId: detailState?.selectedRealtyId,
    selectedRealtyChildrenId: detailState?.selectedRealtyChildrenId,
    start_date: searchStore.start_date,
    end_date: searchStore.end_date,
    cities: searchStore.cities,
    guests: searchStore.guests,
    realty_type_ids: searchStore.realty_type_ids,
    price_min: searchStore.price_min,
    price_max: searchStore.price_max,
    sort: searchStore.sort,
  }

  void setSettingForApp({
    key: ShareKeys.kyrgyzstan,
    value: JSON.stringify(searchFormState),
  })
}

export const clearSearchFormState = () => {
  void setSettingForApp({
    key: ShareKeys.kyrgyzstan,
    value: '',
  })
}
